import { ReactNode } from 'react';
import { TSidebarItem } from './SidebarItems';
import { ListItemButton } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

type Props = {
    children: ReactNode;
    item: TSidebarItem;
};

const allwaysActiveStyle = {
    p: '10px',
    borderRadius: '8px',
    background: 'var(--color-primary-light)',
    color: 'var(--color-primary)',
    fill: 'var(--color-primary)',
    ':hover': {
        background: 'var(--color-primary-light)',
        color: 'var(--color-primary)',
        fill: 'var(--color-primary)',
    },
};

const defaultStyle = {
    p: '10px',
    borderRadius: '8px',
    color: 'var(--color-text-inverse)',
    fill: 'var(--color-text-inverse)',
    justifyContent: 'space-between',
    '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: 'var(--color-sidebar-background-activated)',
        fontWeight: '500',
    },
    '&.Mui-disabled': {
        opacity: '1!important',
    },
};

const SidebarListItemButtonWrapper = ({ children, item }: Props) => {
    const location = useLocation();
    return (
        <ListItemButton
            component={Link}
            to={item.path}
            selected={item.allwaysActive ? false : item.path.split('/')[1] === location.pathname.split('/')[1]}
            sx={item.allwaysActive ? allwaysActiveStyle : defaultStyle}
            disabled={!item.active}
        >
            {children}
        </ListItemButton>
    );
};

export default SidebarListItemButtonWrapper;

